module.exports = __webpack_public_path__ + "img/bsfq.2836c683.svg";